import React from 'react';
import { ClockIcon } from '../common/Icons';

const ServiceItem = ({ name, duration, price, description, onClick }) => {
  return (
    <div className="p-4 border-b last:border-b-0" onClick={onClick}>
      <div className="flex justify-between mb-1">
        <h3 className="font-medium">{name}</h3>
        <span className="font-bold">{price}</span>
      </div>
      <div className="flex justify-between items-center">
        <div>
          <div className="flex items-center text-gray-500 text-sm">
            <ClockIcon size={14} className="mr-1" />
            <span>{duration}</span>
          </div>
          <p className="text-gray-500 text-sm mt-1">{description}</p>
        </div>
        <button className="bg-blue-600 text-white py-2 px-4 rounded-full text-sm">
          Programează
        </button>
      </div>
    </div>
  );
};

export default ServiceItem;